const primaryMain = '#000000';
const primaryMainOpacity = 'rgba(0, 0, 0, 0.9)';
const secondaryMain = '#00669B';
const secondaryMainOpacity = 'rgba(0, 102, 155, 0.5)';
const secondaryLight = '#009EDB';
const tertiaryMain = '#043D5D';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
